import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface IngestionType {
  openFrom: string | null;
  reportMasterDocListId: string | null;
  sourceName: string | null;
  backSourceLabel: string | null;
  backSourcePath: string | null;
}

interface ExportDataState {
  ingestion: IngestionType | null;
}

const initialState: ExportDataState = {
  ingestion: null,
};

const exportDataSlice = createSlice({
  name: 'exportData',
  initialState,
  reducers: {
    setExportDataIngestion(state, action: PayloadAction<IngestionType>) {
      state.ingestion = action.payload;
    },
    clearExportDataIngestion(state) {
      state.ingestion = null;
    },
  },
});

export const {setExportDataIngestion, clearExportDataIngestion} =
  exportDataSlice.actions;
export default exportDataSlice.reducer;
